import { z } from 'zod';
import { request } from './client';

const workspaceSchema = z.object({
  id: z.string(),
  name: z.string(),
  emoji: z.string().nullable().optional(),
  memberCount: z.number(),
  plan: z.enum(['free', 'pro']),
});
export type Workspace = z.infer<typeof workspaceSchema>;

/** GET /api/workspaces/:wsId 详情返回 */
const workspaceDetailSchema = workspaceSchema.extend({
  ownerId: z.string().optional(),
  createdAt: z.string().optional(),
  updatedAt: z.string().optional(),
  docCount: z.number().optional(),
  currentRole: z.enum(['admin', 'editor', 'viewer']).optional(),
});
export type WorkspaceDetail = z.infer<typeof workspaceDetailSchema>;

export const workspacesApi = {
  list: () => request<Workspace[]>('/workspaces'),
  create: (body: { name: string; emoji?: string }) =>
    request<Workspace>('/workspaces', { method: 'POST', body: JSON.stringify(body) }),
  get: (wsId: string) => request<WorkspaceDetail>(`/workspaces/${wsId}`),
  update: (wsId: string, body: { name?: string; emoji?: string }) =>
    request<{ id: string; updated: boolean }>(`/workspaces/${wsId}`, {
      method: 'PATCH',
      body: JSON.stringify(body),
    }),
  remove: (wsId: string) =>
    request<{ id: string; deleted: boolean }>(`/workspaces/${wsId}`, { method: 'DELETE' }),
};
